import script from "./ModalMetodoPago.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMetodoPago.vue?vue&type=script&setup=true&lang=js"

import "./ModalMetodoPago.vue?vue&type=style&index=0&id=e7ef941c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7ef941c"]])

export default __exports__